import { render, staticRenderFns } from "./UserCreateDialog.vue?vue&type=template&id=1dc324c6&scoped=true"
import script from "./UserCreateDialog.vue?vue&type=script&lang=ts"
export * from "./UserCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc324c6",
  null
  
)

export default component.exports